/*
 * @Author: qinqianwen
 * @Date: 2020-08-07 19:55:52
 * @LastEditTime: 2021-05-18 15:32:07
 * @LastEditors: zhanglu
 * @Description: 角色管理api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\roleManage.js
 */

import http from "e6-base-core/axios/config";

import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_E6YUN_BASE_WEB = "" } = e6ModuleBaseDataApi;

//分页获取角色表格数据
export function fetchRoleList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/findByPage`,
    method: "post",
    data
  });
}
//新增角色
export function saveAddRole(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/saveRole`,
    method: "post",
    data
  });
}
//修改角色
export function updateAddRole(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/updateRole`,
    method: "post",
    data
  });
}
//根据角色id获取详情
export function getRoleById(id) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/getRole`,
    method: "get",
    params: {
      id
    }
  });
}
//删除与批量删除角色
export function deleteRole(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/batchDeleteRole`,
    method: "post",
    data
  });
}
//获取权限树
export function fetchOperateList(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/findAllMenuTreeSecondNew`,
    method: "get",
    params
  });
}
//获取角色下拉数据
export function getRoleSelectList(type) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/getListByRoleType`,
    method: "get",
    params: {
      roleType: type
    }
  });
}
//校验角色名称唯一性
export function checkRoleName(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/checkRoleNameIsExist`,
    method: "get",
    params
  });
}
//判断角色是否可删除
export function checkRoleIsAllowDelete(roleId) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/checkRoleIsUse`,
    method: "get",
    params: {
      roleId
    }
  });
}
//角色和用户类型下拉
export function getRoleOrUserTypeList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/role/getRoleOrUserTypeList`,
    method: "post",
    data
  });
}
